import STATES from '@/constants/states.json';

import { CARRIER_TYPE_LABELS, SUPPLY_CHAIN_LEG_LABELS } from './constants';

const labelMapToOptions = (labels) => Object.entries(labels).map(([value, label]) => ({ value, label }));

const STATE_OPTIONS = Object.entries(STATES).map(([code, name]) => ({ value: code, label: name }));
const CARRIER_TYPE_OPTIONS = labelMapToOptions(CARRIER_TYPE_LABELS);
const SUPPLY_CHAIN_LEG_OPTIONS = labelMapToOptions(SUPPLY_CHAIN_LEG_LABELS);

const SHARED_FIELDS = [
    { key: 'business_name', label: 'Company Name', required: true },
    { key: 'email', label: 'Primary Email', required: true, type: 'email' },
    { key: 'business_phone', label: 'Phone', type: 'phone' },
    { key: 'username', label: 'Username' },
    { key: 'billing_email', label: 'Billing Email', type: 'email' },
    { key: 'billing_phone', label: 'Billing Phone', type: 'phone' },
    { key: 'business_address', label: 'Address', colSpan: 4 },
    { key: 'business_address_unit', label: 'Unit', colSpan: 2 },
    { key: 'business_city', label: 'City', colSpan: 2 },
    { key: 'business_state', label: 'State', type: 'select', options: STATE_OPTIONS, colSpan: 2 },
    { key: 'business_zip', label: 'Zip', colSpan: 2 },
    { key: 'billing_address', label: 'Billing Address', billingMirror: 'business_address', colSpan: 4 },
    {
        key: 'billing_address_unit',
        label: 'Billing Unit',
        billingMirror: 'business_address_unit',
        colSpan: 2,
    },
    { key: 'billing_city', label: 'Billing City', billingMirror: 'business_city', colSpan: 2 },
    {
        key: 'billing_state',
        label: 'Billing State',
        type: 'select',
        options: STATE_OPTIONS,
        billingMirror: 'business_state',
        colSpan: 2,
    },
    { key: 'billing_zip', label: 'Billing Zip', billingMirror: 'business_zip', colSpan: 2 },
];

export const CREATE_SHIPPER_CONFIG = {
    title: 'Create Shipper',
    role: 'SHIPPER',
    staticFields: { payment_type: 'INVOICE' },
    fields: [...SHARED_FIELDS],
};

export const CREATE_FLEX_CARRIER_CONFIG = {
    title: 'Create Carrier',
    role: 'CARRIER',
    fields: [
        ...SHARED_FIELDS,
        { key: 'mc_num', label: 'MC #', colSpan: 2 },
        { key: 'dot_number', label: 'DOT #', colSpan: 2 },
        {
            key: 'carrier_type',
            label: 'Type',
            type: 'select',
            options: CARRIER_TYPE_OPTIONS,
            default: 'FLEX',
            colSpan: 2,
        },
        {
            key: 'supply_chain_legs',
            label: 'Supply Chain Legs',
            type: 'multiselect',
            options: SUPPLY_CHAIN_LEG_OPTIONS,
            required: true,
            colSpan: 6,
        },
    ],
};
